import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./MainView.css";

import { LoadingSpinner } from "Projects/CC_cubi_clan_project/GlobalComponents/LoadingSpinner/LoadingSpinner";
import { NavMenu } from "Projects/CC_cubi_clan_project/GlobalComponents/NavMenu/NavMenu";
import { Slider } from "Projects/HAPK_hapkiapp_project/Components/Slider/Slider";


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import Gestionar from "Projects/HAPK_hapkiapp_project/Components/Gestionar/Gestionar";

export default function MainView() {
  const [isLoggedIn, setisLoggedIn] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/");
    } else {
      navigate("/home");
    }
  }, [isLoggedIn]);

  return (
    <div>
      <LoadingSpinner isLoading={isLoading} />
      <NavMenu title="HapkiApp" appCode="HAPK" onLoggedIn={setisLoggedIn} onLoading={setLoading}></NavMenu>
      <Slider></Slider>
      <Gestionar onLoading={setLoading}></Gestionar>

    </div >
  );
}
/*
<MDBContainer>
        <MDBRow className="mt-3">
          <MDBCol size='9'>
            <h2 className="text-center text-hapkido">
              NOTICIAS
            </h2>
            <Noticias onLoading={setLoading} />
          </MDBCol>
          <MDBCol size='3'>
            <div>
              <h2 className="text-center text-hapkido2">EVENTOS</h2>
              <Eventos onLoading={setLoading}></Eventos>
            </div>
          </MDBCol>
        </MDBRow >
      </MDBContainer>
*/